import React from "react";
import {
  TrendingUp,
  Cpu,
  TreePine,
  GraduationCap,
} from "lucide-react";

import { areasAtuacao } from "../data/mockData";

const AreasSection = () => {
  const iconMap = {
    TrendingUp,
    Cpu,
    TreePine,
    GraduationCap,
  };

  return (
    <section id="areas" className="py-20 bg-white">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">
            Áreas de Atuação
          </h2>

          <p className="body-large max-w-3xl mx-auto text-gray-700">
            Nosso trabalho se concentra em quatro pilares fundamentais para
            transformar a Amazônia em um centro de inovação e sustentabilidade
          </p>
        </div>

        {/* Areas Grid */}
        <div className="innovation-grid">
          {areasAtuacao.map((area, index) => {
            const IconComponent = iconMap[area.icon] || Cpu;

            return (
              <div
                key={index}
                className="innovation-card group"
              >
                {/* Icon with gradient background */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-accent-primary to-accent-strong rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>

                  {/* Decorative dot */}
                  <div className="absolute -top-2 -right-2 w-4 h-4 bg-accent-wash rounded-full opacity-60" />
                </div>

                {/* Content */}
                <h3 className="heading-3 mb-4 group-hover:text-accent-text transition-colors">
                  {area.title}
                </h3>

                <p className="body-medium text-gray-600 leading-relaxed">
                  {area.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Innovation Call-to-Action */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-accent-primary to-accent-strong p-8 rounded-2xl text-white">
            <h3 className="heading-3 mb-4 text-white">
              Vamos transformar a Amazônia juntos?
            </h3>

            <p className="body-medium mb-6 text-white/90 max-w-2xl mx-auto">
              Conectamos pessoas, organizações e oportunidades para desenvolver
              soluções que geram inovação, desenvolvimento e impacto na
              Amazônia.
            </p>

            <button className="bg-white text-accent-text px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors">
              Conheça Nossos Projetos
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AreasSection;